import React, { useState } from 'react';
import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const STORAGE_KEY = 'cookieConsent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  }

  return (
    <Paper
      elevation={4}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        px: 3,
        py: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        borderRadius: 0,
      }}
    >
      <Typography variant="body2" sx={{ flex: 1, minWidth: 200 }}>
        Мы используем cookies для работы сайта. Продолжая использование, вы соглашаетесь с нашей{' '}
        <Link component={RouterLink} to="/gdpr">
          Политикой конфиденциальности
        </Link>
        .
      </Typography>
      <Button variant="contained" size="small" onClick={handleAccept}>
        Понятно
      </Button>
    </Paper>
  );
}
